<div *ngIf="!smallScreen; else smallCard" class="card left-quote-card  ">
  <div class="card-header">
    <h6 class="py-1 m-0 text-primary text-center d-flex align-items-center justify-content-center">
      {{'Request a quote for' | translate}} {{ getLocationDisplay() }}
      <a href="javascript:void(0)" class="d-flex align-items-center text-decoration-none">
        <i class="bi bi-info-circle ms-2 info-icon"
          matTooltip="{{ 'Explore available solutions and their costs in two simple steps.' | translate }}"
          matTooltipPosition="above">
        </i>
      </a>
    </h6>
  </div>
  <div class="card-body p-3">
    <form [formGroup]="requestInfoForm">
      <formly-form [fields]="requestInfoFields" [model]="formModel" [form]="requestInfoForm"></formly-form>

      <div class="d-flex justify-content-center mt-3">
        <button type="submit" class="btn btn-primary w-100" (click)="openOfferRequestModal()"
          [disabled]="requestInfoForm.invalid">
          {{ 'Continue' | translate }}
        </button>
      </div>
    </form>

    <div *ngIf="false" class="border-top mt-3 pt-2">
      <small class="text-muted d-block text-start fst-italic" style="font-size: 10px;">
        {{ 'NB. Dental Tour will never provide your phone number to its affiliates without your explicit consent.' |
        translate }}
      </small>
    </div>
  </div>
</div>

<ng-template #smallCard>
  <div [ngClass]="{'fixed-offer-card': isFixed}" (click)="openOfferRequestModal()"
    class="card primary-borders  p-2  d-flex flex-column margin">
    <h5 class="text-primary text fw-semibold free-quote d-flex align-items-center">
      {{'Explore pricing in' | translate}} {{ getLocationDisplay() }}
    </h5>


    <p class="text-muted m-0 text card-text">
      {{"Fill out the form and receive a personalized quote for your dental treatments, without obligation. We will
      contact you as soon as possible!" | translate}}
    </p>

    <div class="w-full d-flex justify-content-end">
      <button type="submit" class="btn btn-link w-auto h-auto card-text " [disabled]="requestInfoForm.invalid">
        {{ 'Continue' | translate }}
      </button>
    </div>
  </div>
</ng-template>